import * as XLSX from "xlsx"
import type { Statistics, DateRange } from "../types"
import { api } from "../services/api"

export const exportStatisticsToExcel = async (statistics: Statistics, dateRange: DateRange) => {
  const workbook = XLSX.utils.book_new()

  // Get all attendance records for the date range
  const attendanceRecords = await api.getAttendanceRecords(dateRange)

  // Get all unique dates in the range, sorted
  const allDates = [...new Set(attendanceRecords.map((r) => r.date))].sort()

  // Create the main data structure
  const fencerData = statistics.fencerStats.map((stat) => {
    const fencerRecords = attendanceRecords.filter((r) => r.fencerId === stat.fencerId)

    // Create the base row
    const row: any = {
      "Fencer Name": stat.name,
      "Training Sessions": stat.trainingCount,
      "Private Lessons": stat.privateLessonCount,
    }

    // Add columns for each date
    allDates.forEach((date) => {
      const record = fencerRecords.find((r) => r.date === date)
      if (record && record.present) {
        // Use '+' for private lesson, 'x' for regular training
        row[date] = record.privateLessonReceived ? "+" : "x"
      } else {
        row[date] = "" // Empty for no attendance
      }
    })

    return row
  })

  // Create the worksheet
  const worksheet = XLSX.utils.json_to_sheet(fencerData)

  // Add the worksheet to workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance Report")

  // Create a summary sheet
  const summaryData = [
    ["Summary", ""],
    ["Date Range", `${dateRange.start} to ${dateRange.end}`],
    ["Total Fencers", statistics.totalFencers],
    ["Total Training Sessions", statistics.trainingAttendance.reduce((sum, item) => sum + item.count, 0)],
    ["Total Private Lessons", statistics.privateLessons.reduce((sum, item) => sum + item.count, 0)],
    [""],
    ["Legend", ""],
    ["x", "Training attendance"],
    ["+", "Training attendance with private lesson"],
    ["(empty)", "No attendance"],
  ]

  const summarySheet = XLSX.utils.aoa_to_sheet(summaryData)
  XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary")

  // Export file
  const fileName = `fencing-attendance-${dateRange.start}-to-${dateRange.end}.xlsx`
  XLSX.writeFile(workbook, fileName)
}
